import BaseService from '_services/rest/base';

class FeedService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/feed`;
  }

  getUrlSave(id, url = '/') {
    if (id) {
      return {
        url: `${this.getUrl()}/${url}${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}/${url}`,
      method: 'POST',
    };
  }

  getLongAccessToken(code) {
    return this.request(`${super.getUrl()}api/facebook/token`, { code })
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getUrlLogin() {
    return this.request(`${super.getUrl()}api/facebook/url-login`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getFilter() {
    return this.request(`${this.getUrl()}/filter`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getTags(search) {
    return this.request(`${this.getUrl()}/tag`, { search })
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getTagFilter() {
    return this.request(`${this.getUrl()}/tag/filter`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getTagsPost(id, token) {
    return this.request(`${this.getUrl()}/post/${id}/tags`, { token })
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  deleteFilter(id) {
    return this.request(`${this.getUrl()}/filter/${id}`, null, 'delete')
      .catch(err => {
        throw err;
      });
  }

  deleteTagFilter(id) {
    return this.request(`${this.getUrl()}/tag/filter/${id}`, null, 'delete')
      .catch(err => {
        throw err;
      });
  }

  saveFilter(model) {
    const meta = this.getUrlSave(model.id, 'filter/');
    return this.request(meta.url, model, meta.method)
      .catch(err => {
        throw err;
      });
  }

  saveTagFilter(model) {
    const meta = this.getUrlSave(model.id, 'tag/filter/');
    return this.request(meta.url, model, meta.method)
      .catch(err => {
        throw err;
      });
  }

  saveTags(model) {
    const meta = {
      url: (model.id) ? `${this.getUrl()}/post/${model.id}/tags` : `${this.getUrl()}/post/tags`,
      method: (model.id) ? 'put' : 'post',
    };
    return this.request(meta.url, model, meta.method)
      .catch(err => {
        throw err;
      });
  }

  saveTagsArrays(tags, posts) {
    return this.request(`${this.getUrl()}/post/tags`, { tags, posts }, 'post')
      .catch(err => {
        throw err;
      });
  }

  getList(pagination) {
    return this.request(`${this.getUrl()}`, pagination)
      .then(response => response.data)
      .catch(err => {
        console.log('err', err);
        throw err;
      });
  }
}

export default new FeedService();
